import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X, Download } from 'lucide-react';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function toCSV(rows) {
  const header = ['Name', 'Email', 'Phone', 'Status', 'Job', 'Date'];
  const body = rows.map((r) => [
    r.name,
    r.email,
    r.phone ? `="${r.phone}"` : '',   // forces Excel to treat this as text, not a number
    r.status,
    r.job || '',
    new Date(r.submittedAt).toLocaleDateString(),
  ]);
  return [header, ...body]
    .map((row) => row.map((v) => `"${String(v).replace(/"/g, '""')}"`).join(','))
    .join('\n');
}

export default function RecruiterCandidatesModal({ recruiterId, recruiterName, month, week, onClose }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE}/api/analytics/candidates`, {
        params: { category: 'totalSourced', month, week, recruiterId },
      })
      .then((res) => setRows(res.data.rows))
      .catch((err) => console.error('Error fetching recruiter candidates:', err))
      .finally(() => setLoading(false));
  }, [recruiterId, month, week]);

  const handleDownload = () => {
    const csv = toCSV(rows);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${recruiterName || 'recruiter'}-candidates.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
            background: '#fff', borderRadius: 12, width: '92%', maxWidth: 1100,   // was 800
            maxHeight: '80vh', display: 'flex', flexDirection: 'column', overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
        >
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '16px 20px', borderBottom: '1px solid #e2e8f0',
        }}>
          <h3 style={{ margin: 0 }}>{recruiterName} — {rows.length} candidates</h3>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn-outline" onClick={handleDownload} disabled={!rows.length}>
              <Download size={16} /> Download CSV
            </button>
            <button className="btn-outline" onClick={onClose}><X size={16} /></button>
          </div>
        </div>

        <div style={{ overflow: 'auto', padding: '0 20px' }}>
  <table className="modern-table" style={{ width: '100%', tableLayout: 'fixed' }}>
    <thead>
      <tr>
        <th style={{ width: '16%' }}>Name</th>
        <th style={{ width: '24%' }}>Email</th>
        <th style={{ width: '14%' }}>Phone</th>
        <th style={{ width: '14%' }}>Status</th>
        <th style={{ width: '22%' }}>Job</th>
        <th style={{ width: '10%' }}>Date</th>
      </tr>
    </thead>
    <tbody>
      {loading && (
        <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24 }}>Loading…</td></tr>
      )}
      {!loading && rows.length === 0 && (
        <tr><td colSpan={6} style={{ textAlign: 'center', padding: 24, color: '#94a3b8' }}>No candidates found</td></tr>
      )}
      {rows.map((r) => (
        <tr key={r.id}>
          <td style={{ wordBreak: 'break-word' }}>{r.name}</td>
          <td style={{ wordBreak: 'break-word' }}>{r.email}</td>
          <td style={{ wordBreak: 'break-word' }}>{r.phone || '—'}</td>
          <td style={{ wordBreak: 'break-word' }}>{r.status}</td>
          <td style={{ wordBreak: 'break-word' }}>{r.job || '—'}</td>
          <td>{new Date(r.submittedAt).toLocaleDateString()}</td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
      </div>
    </div>
  );
}